module.exports = __webpack_public_path__ + "img/masonry.36f62434.png";